/* Strange Quartz banner: four stone dials and four enamels, one at a time.
   Each slide names its set (data-group): the set's tag, its "View all" link and
   its four names on the spine follow the slide on show.
   The ring round the count is the slideshow's clock: it is a CSS animation, and
   the next enamel comes in when it ends, so anything that pauses the ring
   (pointer over the card, keyboard focus inside, card off screen) holds the
   slideshow too. */
(function () {
  'use strict';

  var LEAVE_MS = 900;
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (root.hasAttribute('data-seb-ready')) return;
    root.setAttribute('data-seb-ready', '');

    var card = root.querySelector('.seb__card');
    var slides = [].slice.call(root.querySelectorAll('[data-seb-slide]'));
    var count = slides.length;
    if (!card || count < 2) return;

    var thumbs = [].slice.call(root.querySelectorAll('[data-seb-thumb]'));
    var railItems = [].slice.call(root.querySelectorAll('[data-seb-go]'));
    var nextCard = root.querySelector('[data-seb-nextcard]');
    var indexEl = root.querySelector('[data-seb-index]');
    var toggle = root.querySelector('[data-seb-toggle]');
    var ring = root.querySelector('.seb__ring-run');
    var live = root.querySelector('[data-seb-live]');
    var explore = root.querySelector('[data-seb-explore]');
    var tagEl = root.querySelector('[data-seb-tag]');
    var allEl = root.querySelector('[data-seb-all]');

    var index = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    var leaving = null;
    var leaveTimer = 0;
    var held = false;      // the visitor pressed pause

    function name(i) { return slides[i].getAttribute('data-name') || ''; }

    function fetchImages(scope) {
      [].forEach.call(scope.querySelectorAll('img[data-src]'), function (img) {
        img.src = img.getAttribute('data-src');
        img.removeAttribute('data-src');
      });
    }
    function prepare(i) {
      fetchImages(slides[i]);
      loadCard(i);
      var t = thumbs[(i + 1) % count];
      if (t && t.hasAttribute('data-src')) { t.src = t.getAttribute('data-src'); t.removeAttribute('data-src'); }
    }

    /* A set's card in the homepage list (gwgs-strange-<set>.webp, if it is on the page) shows the same
       watch as the banner while that set is on show: its one picture becomes a stack of the set's four. */
    function group(i) { return slides[i].getAttribute('data-group') || 'enamel'; }
    var stacks = {};
    slides.forEach(function (slide, i) {
      var g = group(i);
      if (!slide.hasAttribute('data-card')) return;
      var st = stacks[g];
      if (st === undefined) {
        var first = document.querySelector('img.gwgs-watch[src*="gwgs-strange-' + g + '"]');
        if (!first) { stacks[g] = null; return; }
        var el = document.createElement('span');
        el.className = 'seb-cardstack';
        first.parentNode.insertBefore(el, first);
        st = stacks[g] = { el: el, first: first, imgs: {}, cur: i };
      }
      if (!st) return;
      var isFirst = Object.keys(st.imgs).length === 0;
      var img = isFirst ? st.first : st.first.cloneNode(false);
      if (!isFirst) {
        img.removeAttribute('src');
        img.removeAttribute('srcset');
        img.setAttribute('data-src', slide.getAttribute('data-card'));
        img.setAttribute('alt', '');
        img.setAttribute('aria-hidden', 'true');
      }
      img.setAttribute('data-alt', slide.getAttribute('data-card-alt') || name(i));
      st.el.appendChild(img);
      st.imgs[i] = img;
    });
    Object.keys(stacks).forEach(function (g) {
      var st = stacks[g];
      if (st) st.imgs[st.cur].classList.add('is-on');
    });
    function loadCard(i) {
      var st = stacks[group(i)];
      var img = st && st.imgs[i];
      if (img && img.hasAttribute('data-src')) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }
    }
    function showCard(to, dir) {
      var st = stacks[group(to)];
      if (!st || st.cur === to || !st.imgs[to]) return;
      loadCard(to);
      st.el.style.setProperty('--seb-dir', dir < 0 ? '-1' : '1');
      var a = st.imgs[st.cur], b = st.imgs[to];
      void b.offsetWidth;
      a.classList.remove('is-on'); a.classList.add('is-off');
      a.setAttribute('alt', ''); a.setAttribute('aria-hidden', 'true');
      b.classList.remove('is-off'); b.classList.add('is-on');
      b.setAttribute('alt', b.getAttribute('data-alt')); b.removeAttribute('aria-hidden');
      st.cur = to;
      setTimeout(function () { a.classList.remove('is-off'); }, calm.matches ? 30 : LEAVE_MS);
    }

    function restartClock() {
      root.classList.remove('is-playing');
      if (held || calm.matches || root.classList.contains('seb--still')) return;
      void root.offsetWidth;
      root.classList.add('is-playing');
    }

    /* the page behind takes the enamel's colour, and its guilloché spirals out from the dial
       (only where the enamel backdrop is on the page; elsewhere these are simply unused) */
    function anchor() {
      var watch = slides[index].querySelector('.seb__watch');
      if (!watch) return;
      var r = watch.getBoundingClientRect();
      if (!r.width) return;
      var doc = document.documentElement;
      doc.style.setProperty('--seb-cx', Math.round(r.left + r.width * 0.5) + 'px');
      doc.style.setProperty('--seb-cy', Math.round(r.top + window.pageYOffset + r.height * 0.45) + 'px');
    }

    function paint() {
      var upNext = (index + 1) % count;
      var slide = slides[index];
      root.setAttribute('data-enamel', slide.getAttribute('data-enamel'));
      root.setAttribute('data-group', group(index));
      if (tagEl && slide.hasAttribute('data-tag')) tagEl.textContent = slide.getAttribute('data-tag');
      if (allEl && slide.hasAttribute('data-all')) allEl.setAttribute('href', slide.getAttribute('data-all'));
      document.documentElement.setAttribute('data-seb-enamel', slides[index].getAttribute('data-enamel'));
      if (indexEl) indexEl.textContent = String(index + 1);
      railItems.forEach(function (b) {
        if (Number(b.getAttribute('data-seb-go')) === index) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-on', Number(t.getAttribute('data-seb-thumb')) === upNext);
      });
      if (nextCard) nextCard.setAttribute('aria-label', 'Next watch: ' + name(upNext));
    }

    function go(to, dir, byVisitor) {
      to = (to % count + count) % count;
      if (to === index) return;
      prepare(to);
      root.classList.remove('seb--intro');
      if (leaving) { leaving.classList.remove('is-leaving'); leaving = null; clearTimeout(leaveTimer); }

      var from = slides[index];
      var next = slides[to];
      var hadFocus = from.contains(document.activeElement);
      root.style.setProperty('--seb-dir', dir < 0 ? '-1' : '1');
      void next.offsetWidth;                 // the incoming slide takes its starting place first

      from.classList.remove('is-active');
      from.classList.add('is-leaving');
      from.setAttribute('aria-hidden', 'true');
      from.inert = true;
      next.classList.add('is-active');
      next.removeAttribute('aria-hidden');
      next.inert = false;
      if (hadFocus) {
        var link = next.querySelector('.seb__title a');
        if (link) link.focus({ preventScroll: true });
      }

      leaving = from;
      leaveTimer = setTimeout(function () {
        from.classList.remove('is-leaving');
        if (leaving === from) leaving = null;
      }, calm.matches ? 30 : LEAVE_MS);

      showCard(to, dir);
      index = to;
      paint();
      restartClock();
      if (byVisitor && live) live.textContent = name(index) + ', ' + (index + 1) + ' of ' + count;
      // have the one after this ready before it is asked for
      setTimeout(function () { prepare((index + 1) % count); }, 900);
    }

    function step(d, byVisitor) { go(index + d, d, byVisitor); }

    /* controls */
    root.addEventListener('click', function (e) {
      var el = e.target.closest('[data-seb-step],[data-seb-go],[data-seb-toggle],[data-seb-explore]');
      if (!el || !root.contains(el)) return;
      if (el.hasAttribute('data-seb-step')) {
        step(Number(el.getAttribute('data-seb-step')), true);
      } else if (el.hasAttribute('data-seb-go')) {
        var to = Number(el.getAttribute('data-seb-go'));
        go(to, to < index ? -1 : 1, true);
      } else if (el.hasAttribute('data-seb-toggle')) {
        held = !held;
        root.classList.toggle('is-held', held);
        el.setAttribute('aria-label', held ? 'Play slideshow' : 'Pause slideshow');
        restartClock();
      } else {
        var bottom = card.getBoundingClientRect().bottom + window.pageYOffset;
        window.scrollTo({ top: bottom - 72, behavior: calm.matches ? 'auto' : 'smooth' });
      }
    });

    slides.forEach(function (slide) {
      var watch = slide.querySelector('.seb__watch');
      var link = slide.querySelector('.seb__title a');
      if (watch && link) watch.addEventListener('click', function () { link.click(); });
    });

    root.addEventListener('keydown', function (e) {
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      if (e.key === 'ArrowRight') { step(1, true); e.preventDefault(); }
      else if (e.key === 'ArrowLeft') { step(-1, true); e.preventDefault(); }
    });

    if (ring) {
      ring.addEventListener('animationend', function (e) {
        if (e.animationName === 'seb-ring') step(1, false);
      });
    }

    /* a sideways swipe on a touch screen */
    var sx = 0, sy = 0, tracking = false;
    card.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      tracking = true; sx = e.clientX; sy = e.clientY;
    });
    card.addEventListener('pointerup', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4) step(dx < 0 ? 1 : -1, true);
    });
    card.addEventListener('pointercancel', function () { tracking = false; });

    /* the slideshow runs while the banner, or a set's card below it, is on screen */
    if ('IntersectionObserver' in window) {
      var inView = { banner: true };
      var watchFor = function (el, key) {
        inView[key] = inView[key] || false;
        new IntersectionObserver(function (entries) {
          inView[key] = entries[0].isIntersecting;
          root.classList.toggle('is-offscreen', !Object.keys(inView).some(function (k) { return inView[k]; }));
        }, { threshold: 0.35 }).observe(el);
      };
      watchFor(card, 'banner');
      Object.keys(stacks).forEach(function (g) { if (stacks[g]) watchFor(stacks[g].el, 'card-' + g); });
    }

    /* ?still=slate shows one enamel as a picture (used to render the image version) */
    var still = /[?&]still=([a-z]+)/.exec(window.location.search);
    if (still) {
      var at = slides.findIndex(function (s) { return s.getAttribute('data-enamel') === still[1]; });
      root.classList.add('seb--still');
      root.classList.remove('seb--intro');
      document.body.classList.add('demo--still');
      thumbs.forEach(function (t) { if (t.hasAttribute('data-src')) { t.src = t.getAttribute('data-src'); t.removeAttribute('data-src'); } });
      if (at > 0) {
        fetchImages(slides[at]);
        slides[index].classList.remove('is-active');
        slides[at].classList.add('is-active');
        index = at;
      }
    }

    if (explore) explore.hidden = false;
    paint();
    anchor();
    window.addEventListener('load', anchor);
    var anchorTimer = 0;
    window.addEventListener('resize', function () { clearTimeout(anchorTimer); anchorTimer = setTimeout(anchor, 200); });
    if (!still) {
      // the first enamel plays its entrance, then the clock starts
      var start = function () {
        setTimeout(function () { root.classList.remove('seb--intro'); restartClock(); prepare((index + 1) % count); }, calm.matches ? 0 : 1500);
      };
      if (document.readyState === 'complete') start();
      else window.addEventListener('load', start, { once: true });
    }
  }

  function boot(scope) {
    [].forEach.call((scope || document).querySelectorAll('[data-seb]'), init);
  }
  boot();
  document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
